(function() {
  var config = window.MG_PROMO_CONFIG || {};
  var apiUrl = config.apiUrl || 'https://www.medicalguardian.com/rebrand/ci_app_csrf';
  var defaultAid = config.defaultAid != null ? config.defaultAid : '';
  var cookieDays = config.cookieMaxAgeDays != null ? config.cookieMaxAgeDays : 1;
  var legacyDefaultAids = config.legacyDefaultAids && config.legacyDefaultAids.length
    ? config.legacyDefaultAids
    : ['4'];
  var siteDefaultAid = config.siteDefaultAid != null ? String(config.siteDefaultAid).trim() : '5214';
  var quizDefaultAid = config.quizDefaultAid != null ? String(config.quizDefaultAid).trim() : '5754';
  var pageDefaultAid = defaultAid != null ? String(defaultAid).trim() : '';

  function getParam(name) {
    var match = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim() : '';
  }

  function getCookie(name) {
    var v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return v ? v.pop().trim() : '';
  }

  function getCookieDomain() {
    try {
      var host = typeof window !== 'undefined' && window.location && window.location.hostname ? window.location.hostname : '';
      if (host === 'mobilehelp.com' || host.indexOf('.mobilehelp.com') > -1) {
        return ';domain=.mobilehelp.com';
      }
    } catch (e) {}
    return '';
  }

  function clearCookieHostOnly(name) {
    document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;Max-Age=0';
  }

  function setCookie(name, value, days) {
    var domain = getCookieDomain();
    if (domain) {
      clearCookieHostOnly(name);
    }
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/' + domain + ';expires=' + d.toUTCString() + ';SameSite=Lax';
  }

  function validParam(p) {
    return p && p !== 'undefined' && p !== 'null';
  }

  function isLegacyStoredAid(p) {
    if (!validParam(p)) return false;
    var s = String(p).trim();
    for (var i = 0; i < legacyDefaultAids.length; i++) {
      if (String(legacyDefaultAids[i]).trim() === s) return true;
    }
    return false;
  }

  /** When this template's defaultAid differs from site default, do not reuse site default from storage (e.g. quiz vs rest of site). */
  function isSiteDefaultCarriedToQuizPage(p) {
    if (!validParam(p) || !pageDefaultAid || !siteDefaultAid) return false;
    if (pageDefaultAid === siteDefaultAid) return false;
    return String(p).trim() === siteDefaultAid;
  }

  /** On normal pages (site default), do not keep quiz default from storage after visiting the quiz. URL ?aid= still wins above. */
  function isQuizDefaultCarriedToNonQuizPage(p) {
    if (!validParam(p) || !quizDefaultAid || !siteDefaultAid || !pageDefaultAid) return false;
    if (pageDefaultAid !== siteDefaultAid) return false;
    return String(p).trim() === quizDefaultAid;
  }

  function acceptStoredAid(p) {
    return validParam(p) &&
      !isLegacyStoredAid(p) &&
      !isSiteDefaultCarriedToQuizPage(p) &&
      !isQuizDefaultCarriedToNonQuizPage(p);
  }

  function resolveAid() {
    var p = getParam('aid');
    if (validParam(p)) return p;
    p = getCookie('aid');
    if (acceptStoredAid(p)) return p;
    p = getCookie('_mg_aid');
    if (acceptStoredAid(p)) return p;
    try {
      p = localStorage.getItem('_mg_aid');
      if (acceptStoredAid(p)) return p;
      p = sessionStorage.getItem('aid');
      if (acceptStoredAid(p)) return p;
    } catch (e) {}
    return defaultAid != null ? defaultAid : '';
  }

  function formatPhoneNumber(number) {
    if (!number) return '';
    var digits = String(number).replace(/\D/g, '').replace(/^1/, '');
    var m = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    return m ? m[1] + '-' + m[2] + '-' + m[3] : number;
  }

  function formatLinkNumber(number) {
    if (!number) return '';
    var digits = String(number).replace(/\D/g, '').replace(/^1/, '');
    var m = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    return m ? m[1] + '-' + m[2] + '-' + m[3] : number;
  }

  function getPhoneDigits(number) {
    if (!number) return '';
    return String(number).replace(/\D/g, '');
  }

  function isValidPhone(value) {
    if (value == null || value === '') return false;
    var digits = String(value).replace(/\D/g, '');
    return digits.length >= 10;
  }

  function extractDisplayNumber(data) {
    if (!data || typeof data !== 'object') return '';
    var results = data.results || data;
    var keys = ['display_number', 'display_number_phone', 'phone_number', 'phone', 'number', 'contact_phone', 'cs_phone'];
    for (var i = 0; i < keys.length; i++) {
      var val = results[keys[i]];
      if (val != null && val !== '') {
        var s = String(val).trim();
        if (isValidPhone(s)) return s;
      }
    }
    if (typeof results === 'object') {
      for (var k in results) {
        if (results.hasOwnProperty(k) && /phone|number|tel/i.test(k)) {
          var v = results[k];
          if (v != null && v !== '' && isValidPhone(v)) return String(v).trim();
        }
      }
    }
    if (data.display_number && isValidPhone(data.display_number)) return String(data.display_number).trim();
    if (data.phone_number && isValidPhone(data.phone_number)) return String(data.phone_number).trim();
    return '';
  }

  function isPhoneLike(text) {
    if (!text || typeof text !== 'string') return false;
    var digits = text.replace(/\D/g, '');
    return digits.length >= 10;
  }

  var STORAGE_AID_PHONES = '_mg_aid_phones';
  var trackingParams = [
    'aid','subid','subid1','subid2',
    'gclid','fbclid','msclkid',
    'utm_source','utm_medium','utm_campaign',
    'p4','forbes_tid','gaVisitor'
  ];

  function getAidPhonesMap() {
    try {
      var raw = localStorage.getItem(STORAGE_AID_PHONES);
      if (!raw) return {};
      var map = JSON.parse(raw);
      return typeof map === 'object' && map !== null ? map : {};
    } catch (e) {
      return {};
    }
  }

  function setPhoneForAid(aid, displayNumber) {
    if (!validParam(aid) || !validParam(displayNumber)) return;
    try {
      var map = getAidPhonesMap();
      map[aid] = displayNumber;
      localStorage.setItem(STORAGE_AID_PHONES, JSON.stringify(map));
    } catch (e) {}
  }

  function getPhoneForAid(aid) {
    if (!validParam(aid)) return '';
    var map = getAidPhonesMap();
    return map[aid] || '';
  }

  function setCartPhoneAttribute(displayNumber) {
    if (!validParam(displayNumber)) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { mg_phone: displayNumber } })
      }).catch(function() {});
    } catch (e) {}
  }

  function replaceSitePhones(displayNumber, formattedNumber) {
    if (!displayNumber) return;
    var digits = getPhoneDigits(displayNumber);
    if (digits.length < 10) return;
    if (!formattedNumber) formattedNumber = formatPhoneNumber(displayNumber);

    var telHref = 'tel:' + digits;

    function replacePhoneTextInNode(node, newNumber) {
      if (node.nodeType === 3) {
        var text = (node.textContent || '').trim();
        if (isPhoneLike(text)) {
          node.textContent = newNumber;
        }
        return;
      }
      if (node.nodeType === 1 && node.childNodes && node.childNodes.length) {
        for (var i = 0; i < node.childNodes.length; i++) {
          replacePhoneTextInNode(node.childNodes[i], newNumber);
        }
      }
    }

    document.querySelectorAll('a[href^="tel:"]').forEach(function(link) {
      link.setAttribute('href', telHref);
      var phoneEl = link.querySelector('.mh-dynamic-phone');
      if (phoneEl) {
        phoneEl.textContent = formattedNumber;
      } else if (link.children.length === 0) {
        var text = (link.textContent || '').trim();
        if (isPhoneLike(text)) {
          link.textContent = formattedNumber;
        }
      } else {
        replacePhoneTextInNode(link, formattedNumber);
      }
    });

    document.querySelectorAll('.mh-dynamic-phone').forEach(function(el) {
      el.textContent = formattedNumber;
    });

    window.MG_PROMO_PHONE = { digits: digits, formatted: formattedNumber };
  }

  function applyStoredDisplayNumber(aid) {
    if (!validParam(aid)) return;
    var stored = getPhoneForAid(aid);
    if (!stored || !validParam(stored)) return;
    setCookie('_mg_phone', stored, cookieDays);
    var formatted = formatPhoneNumber(stored);
    if (formatted) replaceSitePhones(stored, formatted);
    setCartPhoneAttribute(stored);
  }

  function escapeAttr(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function renderContainer(param, data) {
    var results = data.results || {};
    var token = data.token != null ? data.token : '';
    var promoCode = results.promo_code != null ? results.promo_code : '';
    var displayNumber = extractDisplayNumber(data) || (results.display_number != null ? String(results.display_number).trim() : '');
    var formattedNumber = formatPhoneNumber(displayNumber);
    var linkNumber = formatLinkNumber(displayNumber);

    var root = document.getElementById('aid-container-placeholder');
    if (!root) return;

    var div = document.createElement('div');
    div.id = 'aid-container';
    div.setAttribute('data-test', 'mg-test');
    div.setAttribute('data-aid', escapeAttr(param));

    var inputs = [
      { id: 'csrf_token', name: 'X-CSRF-TOKEN', value: token },
      { id: 'promo_code', name: 'promo_code', value: promoCode },
      { id: 'display_number', name: 'display_number', value: displayNumber },
      { id: 'formatted_number', name: 'formatted_number', value: formattedNumber },
      { id: 'link_number', name: 'link_number', value: linkNumber },
      { id: 'aid', name: 'aid', value: param }
    ];

    inputs.forEach(function(inp) {
      var el = document.createElement('input');
      el.type = 'hidden';
      el.id = inp.id;
      el.name = inp.name;
      el.value = inp.value;
      div.appendChild(el);
    });

    root.parentNode.replaceChild(div, root);

    try {
      sessionStorage.setItem('aid', param);
      localStorage.setItem('_mg_aid', param);
    } catch (e) {}

    if (validParam(param)) {
      setCookie('aid', param, cookieDays);
      setCookie('_mg_aid', param, cookieDays);
      setCookie('_is_shopify', '1', cookieDays);
    }

    if (!validParam(displayNumber)) {
      var urlPhone = getParam('mg_phone') || getParam('phone');
      if (validParam(urlPhone) && isValidPhone(urlPhone)) {
        displayNumber = String(urlPhone).trim();
        formattedNumber = formatPhoneNumber(displayNumber);
      }
    }
    if (validParam(displayNumber)) {
      setPhoneForAid(param, displayNumber);
      setCookie('_mg_phone', displayNumber, cookieDays);
      if (param !== defaultAid) {
        replaceSitePhones(displayNumber, formattedNumber);
        setCartPhoneAttribute(displayNumber);
      }
    } else {
      if (param !== defaultAid) {
        applyStoredDisplayNumber(param);
      }
    }

    document.dispatchEvent(new CustomEvent('mgPromoLoaded', {
      detail: { aid: param, displayNumber: displayNumber, formattedNumber: formattedNumber }
    }));
  }

  function applyAidAttribution(param) {
    if (validParam(param)) {
      setCookie('aid', param, cookieDays);
      setCookie('_mg_aid', param, cookieDays);
      setCookie('_is_shopify', '1', cookieDays);
      try {
        sessionStorage.setItem('aid', param);
        localStorage.setItem('_mg_aid', param);
      } catch (e) {}
      if (param !== defaultAid) {
        applyStoredDisplayNumber(param);
      }
    } else {
      setCookie('aid', '', cookieDays);
      setCookie('_mg_aid', '', cookieDays);
    }
  }

  function patchAidContainer(aid) {
    if (!validParam(aid)) return false;
    var div = document.getElementById('aid-container');
    if (!div) return false;
    div.setAttribute('data-aid', escapeAttr(aid));
    var input = div.querySelector('input#aid');
    if (input) input.value = aid;
    var byName = div.querySelector('input[name="aid"]');
    if (byName && byName !== input) byName.value = aid;
    return true;
  }

  function loadPromoForAid(param) {
    var url = apiUrl + '?aid=' + encodeURIComponent(param);
    return fetch(url, { method: 'GET', credentials: 'omit' })
      .then(function(res) { return res.text(); })
      .then(function(body) {
        var data;
        try {
          data = JSON.parse(body);
        } catch (e) {
          renderContainer(param, {});
          return;
        }
        if (data && data.results) {
          renderContainer(param, data);
        } else {
          renderContainer(param, {});
        }
      })
      .catch(function() {
        renderContainer(param, {});
      });
  }

  window.MG_PROMO_APPLY_AID = function(aid, opts) {
    opts = opts || {};
    if (!validParam(aid)) return;
    applyAidAttribution(aid);
    patchAidContainer(aid);
    if (opts.refetch) {
      loadPromoForAid(aid);
    }
  };

  function handleTrackingParams() {
    trackingParams.forEach(function(param) {
      var val = getParam(param);
      if (val) {
        setCookie(param, val, 30);
      }
    });

    function populate() {
      trackingParams.forEach(function(param) {
        var val = getCookie(param);
        if (!val) return;
        document.querySelectorAll('form').forEach(function(form) {
          var input = form.querySelector('input[name="' + param + '"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = param;
            form.appendChild(input);
          }
          input.value = val;
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', populate);
    } else {
      populate();
    }
  }

  function run() {
    handleTrackingParams();
    var param = resolveAid();
    applyAidAttribution(param);
    loadPromoForAid(param);
  }

  // Runs as soon as this script loads (sync snippet in body). Deferred bundles
  // (e.g. quiz) execute before DOMContentLoaded, so session/cookies must match
  // resolved AID before those scripts run — not only on DOMContentLoaded.
  (function syncAidImmediately() {
    try {
      var param = resolveAid();
      applyAidAttribution(param);
    } catch (e) {}
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
